/* A closed disclosure. Tokens only (ADR-0007). The summary matches the Inventory screens' own
   disclosure so the product has one closed-control look. */

/* A disclosure sits in the shell body's twelve-column grid on the screens that have not moved over:
   without a span it took one column and its summary wrapped a word to a line. */
.disclosure {
  grid-column: 1 / -1;
  min-width: 0;
}

.disclosure > summary {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  cursor: pointer;
  font-size: var(--t-dense);
  font-weight: 600;
  color: var(--accent);
}

.disclosure > summary:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.disclosure > summary:active {
  color: var(--ink);
}

.disclosure > summary:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 3px;
}

.disclosure[open] > summary {
  margin-bottom: 8px;
}

.disclosure[open] > summary svg {
  transform: rotate(90deg);
}

.body {
  display: grid;
  gap: 8px;
  min-width: 0;
  font-size: var(--t-min);
  line-height: 1.55;
  color: var(--ink-2);
}

.body p {
  margin: 0;
  max-width: 80ch;
  overflow-wrap: anywhere;
}
